export default __webpack_public_path__ + "static/media/tracker.763ccb60.png";